import { render, staticRenderFns } from "./FCA.vue?vue&type=template&id=196fdc9b&scoped=true&"
import script from "./FCA.vue?vue&type=script&lang=js&"
export * from "./FCA.vue?vue&type=script&lang=js&"
import style0 from "./FCA.vue?vue&type=style&index=0&id=196fdc9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fdc9b",
  null
  
)

export default component.exports